export default "__VITE_ASSET__gl6eH5rr__"